import { render, staticRenderFns } from "./BedInpatient.vue?vue&type=template&id=2a61bf01&scoped=true"
import script from "./BedInpatient.vue?vue&type=script&lang=js"
export * from "./BedInpatient.vue?vue&type=script&lang=js"
import style0 from "./BedInpatient.vue?vue&type=style&index=0&id=2a61bf01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61bf01",
  null
  
)

export default component.exports